import "../scss/styles.scss";
import PageCommon	from "./pages/PageCommon.js";
import PageDefault	from "./pages/PageDefault.js";
import PageGeneric from "./pages/PageGeneric.js";
import PageArchiveProjects from "./pages/PageArchiveProjects.js";


import ServiceManager from "./3x1010/services/ServiceManager.js";

export default class App {

	static factory(cls) {
		return new App.classes[cls]();
	}

}
// PAGINE
App.classes = {
	PageCommon, PageDefault, PageGeneric,
	PageArchiveProjects
};

// ALTRE CLASSI ESPORTATE ESPLICITAMENTE
window.Class = {};
window.Class.ServiceManager = ServiceManager;
window.Class.PageCommon = PageCommon; 